import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'cm-closing-info-display',
  standalone: true,
  templateUrl: './closing-info-display.component.html',
  styleUrl: './closing-info-display.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClosingInfoDisplayComponent {
  public readonly closingReason = input<string | null>(null);
  public readonly closingNotes = input<string | null>(null);
}
